module.exports = __webpack_public_path__ + "src/img/grid_noise.208293446f18d3966fb2a8477a347351.png";